import script from "./confirm-action-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-action-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__